import useScrollTrigger from '@mui/material/useScrollTrigger';
import Zoom from '@mui/material/Zoom';

import { ScrollToTopProps } from './props';
import StyledScrollToTop from './styled';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const ScrollToTop: React.FC<ScrollToTopProps> = (props) => {
  const { children, className } = props;

  // =============== HOOKS
  const trigger = useScrollTrigger({
    threshold: 400,
    disableHysteresis: true,
  });

  // =============== EVENTS
  const handleClick = () => {
    const anchor = document.querySelector('body');
    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // =============== VIEWS
  return (
    <Zoom in={trigger}>
      <StyledScrollToTop
        className={className}
        onClick={handleClick}
        role="presentation"
      >
        {children}
      </StyledScrollToTop>
    </Zoom>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default ScrollToTop;
